import { Box, styled } from "@mui/material";

export const CustomContainer = styled(Box)(
  ({theme:{palette}}) => `
 & .swiper-button-next{
    color:${palette.primary.main}!important;
 }

 & .swiper-button-prev{
    color:${palette.primary.main}!important;
 }

 & .MuiPaper-root{
    padding-top: 26px;
 }
`
)
